import { WcNotificationService } from './wc-notification.service.js';
class WcShared {
    constructor() {
        this.store = window['webComponentsStore'];
        this.notificationService = WcNotificationService.getInstance(); // exposes the unique instance of notificationService
    }
    translate(text, params, allowedTag, allowedAttr) {
        return this.store?.translate(text, params, allowedTag, allowedAttr);
    }
    extractSpaceIdFromHref() {
        if (this.store.utils.isKsuite()) {
            const splittedPathname = window.location.pathname.split('/');
            return Number(Boolean(splittedPathname[1]) ? splittedPathname[1] : null);
        }
        return Number(this.store.currentSpace?.id);
    }
    matomo({ category, action, value, accountId }) {
        this.httpCall('POST', '/api/web-components/1/analytics', {
            project: 'web-components',
            category,
            action,
            value,
            account_id: accountId,
        }).then(async (response) => {
            try {
                await response.json();
            }
            catch { }
        });
    }
    async httpCall(method, url, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body, forceMock = false, formData = false) {
        const response = await this.fetchApi(method, url, body, forceMock, formData);
        if (await this.getHttpCallMustRetry(response.status)) {
            return this.fetchApi(method, url, body, forceMock, formData);
        }
        return response;
    }
    /**
     * ReAuth if response status is 419 (or ones set in params)
     */
    async getHttpCallMustRetry(status, statuses = [419]) {
        if (statuses.includes(status)) {
            return await this.fetchApi('GET', '/api/web-components/1/csrf-cookie').then((response) => response.ok);
        }
        return false;
    }
    async fetchApi(method, url, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body, forceMock = false, formeData = false) {
        let urlMock;
        if (this.hasMock() || forceMock) {
            const mockType = this.getMockType();
            const response = await this.fetchMock('/mocks/default.json');
            const urlFormated = this.formatUrlForMock(url);
            urlMock = response?.[mockType]?.[method]?.url?.[urlFormated];
            if (!urlMock) {
                urlMock = response?.default?.[method].url[urlFormated];
                if (urlMock) {
                    return fetch(urlMock);
                }
            }
            else {
                return fetch(urlMock);
            }
        }
        if (!urlMock) {
            // url = 'http://shop.devd358.dev.infomaniak.ch' + url;
            url = this.store?.apiEndpoint + url.replace('/api/components/', '/api/web-components/1/');
            const headers = {
                'X-Requested-With': 'XMLHttpRequest',
            };
            if (!formeData) {
                headers['Content-type'] = 'application/json;charset=UTF-8';
            }
            if (method !== 'GET' && !this.store.wcToken) {
                headers['X-XSRF-TOKEN'] = decodeURIComponent(this.getCookie('WC-XSRF-TOKEN'));
            }
            if (this.store.wcToken) {
                headers['Authorization'] = `Bearer ${this.store.wcToken}`;
            }
            return fetch(url, {
                method,
                ...(!this.store.wcToken && { credentials: 'include' }),
                body: formeData ? body : JSON.stringify(body),
                headers: new Headers(headers),
            });
        }
    }
    formatUrlForMock(url) {
        url = this.formatMockLang(url);
        url = this.formatMockId(url);
        url = this.formatMockSearch(url);
        return url;
    }
    // Format lang to have only Fr lang
    formatMockLang(url) {
        if (url.includes('lang=')) {
            const index = url.indexOf('lang=');
            if (url.length >= index + 2) {
                const str = url.split('');
                str[index + 5] = 'f';
                str[index + 6] = 'r';
                url = str.join('');
            }
        }
        return url;
    }
    // Format URL for params with id or number
    formatMockId(url) {
        return url
            .split('/')
            .map((item) => {
            return isNaN(parseInt(item, 10)) ? item : 1;
        })
            .join('/');
    }
    // Format URL for params search
    formatMockSearch(url) {
        if (url.includes('&')) {
            url = url
                .split('&')
                .map((param) => {
                const paramSplit = param.split('=');
                if (paramSplit[0] === 'search') {
                    return paramSplit[0] + '=mail';
                }
                else {
                    return paramSplit.join('=');
                }
            })
                .join('&');
        }
        return url;
    }
    hasMock() {
        return window['CYPRESS_ENABLED'];
    }
    getMockType() {
        return window['CYPRESS_MOCK_TYPE'];
    }
    async fetchMock(url) {
        const response = await fetch(url, { method: 'GET' });
        return await response.json();
    }
    getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match && match.length >= 2)
            return match[2];
    }
    displayComponent(name) {
        document.querySelectorAll(`.wc-trigger-${name}`).forEach((htmlElement) => {
            htmlElement.style.display = 'block';
        });
        document
            .querySelectorAll(`.wc-trigger-${name}--flex`)
            .forEach((htmlFlexElement) => {
            htmlFlexElement.style.display = 'flex';
        });
    }
}
export default new WcShared();
